import React, { useEffect, useState } from 'react'
import services from 'services/index'
import { Chart, Head, Header, Info } from './components'
import { defaulFilter } from './constants'

const Main = () => {
	const [data, setData] = useState()
	const [chartData, setChartData] = useState([])
	const [loading, setLoading] = useState(false)
	const [filter, setFilter] = useState(defaulFilter)

	const getStatistics = filter => {
		const options = {
			onEnd: () => setLoading(false),
			onError: () => setData([]),
			onStart: () => setLoading(true),
			filter,
			onSuccess: response => {
				const paidTotal = response?.data?.paid_total
				const expectedTotal = response?.data?.expected_total
				setChartData([
					{
						value: paidTotal,
						name: "To'lov qilingan",
					},
					{
						value: expectedTotal - paidTotal,
						name: "To'lov qilinmagan",
					},
				])
				setData(response?.data)
			},
		}
		services.dashboard.getStatistics(options)
	}
	useEffect(() => {
		getStatistics(filter)
	}, [filter])
	return (
		<div className='p-6'>
			<Head />
			<Header filter={filter} setFilter={setFilter} />
			<div className='grid grid-cols-12 mt-4 gap-6'>
				<div className='col-span-12 xl:col-span-6'>
					<div className='border-[#E4E4E4] dark:border-[#FFFFFF33] border-[1px] rounded-[15px] pb-3 bg-[linear-gradient(0deg,#FFFFFF,#FFFFFF),linear-gradient(97.29deg,rgba(161,158,158,0.15)_-0.29%,rgba(255,255,255,0)_51.75%,rgba(161,158,158,0.15)_102.8%)] dark:bg-[linear-gradient(0deg,rgba(171,171,171,0.03),rgba(171,171,171,0.03)),linear-gradient(98.23deg,rgba(255,255,255,0.13)_-1.89%,rgba(73,73,73,0)_51.47%,rgba(255,255,255,0.13)_104.51%)] backdrop-filter-[blur(7px)]'>
						<Chart data={chartData} isLoading={loading} />
					</div>
				</div>
				<div className='col-span-12 xl:col-span-6'>
					<Info {...data} />
				</div>
			</div>
		</div>
	)
}

export default Main
